module.exports = __webpack_public_path__ + "fonts/montserrat-lightitalic-webfont.2331912.woff";